const ovUtilities = {
  customErrors: {},
  addLiferayParamToJSON: function (namespace, element, data) {
    let result = data ? data : {}
    if (namespace && element) {
      data[namespace + element.name] = element.value
    }
    return result
  },
  addMobileEvents: function (element, actionEvent) {
    element.addEventListener('input', actionEvent)
    element.addEventListener('countrychange', actionEvent)
  },
  setLabelValidationInput: (element, label)=> {
    element.setAttribute('data-label-validation', label)
  },
  /**
   * Valida un campo IBAN verificando primero el país y luego el formato
   * @param {HTMLElement} element - El elemento input que contiene el IBAN
   * @returns {Promise<void>}
   */
  setInputValidationIBAN: async function(element) {
    const isValidCountry = await acOvTheme.isValidCountry(element.value)
    if (!isValidCountry) {
      ovUtilities.setLabelValidationInput(element, acOvTheme.getLabelErrorIbanCountry(true))
      ovUtilities.setInputValidation(element, false)
      return
    }

    const result = await acOvTheme.validateIBAN(element.value)
    if (result) {
      ovUtilities.setInputValidation(element, true, element.parentNode.parentNode.querySelector('.field-help'))
    } else {
      ovUtilities.setLabelValidationInput(element, acOvTheme.getLabelErrorIbanCountry(false))
      ovUtilities.setInputValidation(element, false)
    }
  },
  /**
   * Valida un elemento de cuenta bancaria (IBAN) con manejo completo de errores
   * Esta función es reutilizable por múltiples módulos
   * @param {HTMLElement} bankAccountElement - El elemento input que contiene el IBAN
   * @param {Function} [callback] - Callback opcional a ejecutar después de la validación
   * @returns {Promise<void>}
   */
  validateBankAccountElement: async function(bankAccountElement, callback) {
    if (bankAccountElement.value !== '') {
      try {
        await ovUtilities.setInputValidationIBAN(bankAccountElement)
      } catch (error) {
        console.error('Error validating bank account:', error)
        ovUtilities.setInputValidation(bankAccountElement, false)
      } finally {
        if (typeof callback === 'function') {
          callback()
        }
      }
    }
  },
  setInputValidation: (element, isValid = true, helper = undefined) => {
    if (['checkbox', 'range', 'radio', 'button', 'submit'].includes(element.type)) return

    const baseClass = ['date', 'time'].includes(element.type) ? '-no-image' : ''
    const validationKey = element.getAttribute('data-label-validation')
    const baseErrorId = `error-label-${validationKey}_${element.id}`
    const existingErrorElement = document.getElementById(baseErrorId)

    if (element.nextSibling?.id !== baseErrorId) element.nextSibling?.remove()

    if (element.value) {
      if (isValid) {
        element.classList.remove(`wrong${baseClass}`)
        element.classList.add(`correct${baseClass}`)
        helper?.classList.remove('hide')
        existingErrorElement?.remove()
      } else {
        element.classList.remove(`correct${baseClass}`)
        element.classList.add(`wrong${baseClass}`)
        helper?.classList.add('hide')
        if (!existingErrorElement) element.insertAdjacentElement('afterend', generateErrorLabel())
      }
    } else {
      element.classList.remove(`wrong${baseClass}`)
      element.classList.remove(`correct${baseClass}`)
      helper?.classList.remove('hide')
      existingErrorElement?.remove()
    }

    function generateErrorLabel() {
      const errorLabel = document.createElement('span')
      errorLabel.id = baseErrorId
      errorLabel.textContent = ovUtilities.customErrors[validationKey] ?? ovUtilities.customErrors['generic']
      errorLabel.classList.add('text-help', 'wrong')
      errorLabel.setAttribute('data-testid', baseErrorId)

      return errorLabel
    }
  },
  insertRichTextEditor: (idContainer, placeholder) => {
    if (!document.querySelector(idContainer)) {
      console.error(`Container not found while initializing rich text editor: ${idContainer}`);
      return null;
    }
    return new Quill(idContainer, {
      theme: 'snow',
      modules: {
        toolbar: true,
        keyboard: {
          bindings: {
            'tab': {
              key: 9,
              handler: function() {
                return true;
              }
            }
          }
        }
      },
      placeholder: placeholder,
    });
  },
  capitalizeFirstLetter: (text) => {
    return text
      ?.toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  },
  countryList: {
    '+93': 'AF',
    '+358': 'AX',
    '+355': 'AL',
    '+213': 'DZ',
    '+1684': 'AS',
    '+376': 'AD',
    '+244': 'AO',
    '+1264': 'AI',
    '+672': 'AQ',
    '+1268': 'AG',
    '+54': 'AR',
    '+374': 'AM',
    '+297': 'AW',
    '+61': 'AU',
    '+43': 'AT',
    '+994': 'AZ',
    '+1242': 'BS',
    '+973': 'BH',
    '+880': 'BD',
    '+1246': 'BB',
    '+375': 'BY',
    '+32': 'BE',
    '+501': 'BZ',
    '+229': 'BJ',
    '+1441': 'BM',
    '+975': 'BT',
    '+591': 'BO',
    '+387': 'BA',
    '+267': 'BW',
    '+55': 'BR',
    '+246': 'IO',
    '+673': 'BN',
    '+359': 'BG',
    '+226': 'BF',
    '+257': 'BI',
    '+855': 'KH',
    '+237': 'CM',
    '+1': 'CA',
    '+238': 'CV',
    '+ 345': 'KY',
    '+236': 'CF',
    '+235': 'TD',
    '+56': 'CL',
    '+86': 'CN',
    '+61': 'CX',
    '+61': 'CC',
    '+57': 'CO',
    '+269': 'KM',
    '+242': 'CG',
    '+243': 'CD',
    '+682': 'CK',
    '+506': 'CR',
    '+225': 'CI',
    '+385': 'HR',
    '+53': 'CU',
    '+357': 'CY',
    '+420': 'CZ',
    '+45': 'DK',
    '+253': 'DJ',
    '+1767': 'DM',
    '+1849': 'DO',
    '+593': 'EC',
    '+20': 'EG',
    '+503': 'SV',
    '+240': 'GQ',
    '+291': 'ER',
    '+372': 'EE',
    '+251': 'ET',
    '+500': 'FK',
    '+298': 'FO',
    '+679': 'FJ',
    '+358': 'FI',
    '+33': 'FR',
    '+594': 'GF',
    '+689': 'PF',
    '+241': 'GA',
    '+220': 'GM',
    '+995': 'GE',
    '+49': 'DE',
    '+233': 'GH',
    '+350': 'GI',
    '+30': 'GR',
    '+299': 'GL',
    '+1473': 'GD',
    '+590': 'GP',
    '+1671': 'GU',
    '+502': 'GT',
    '+44': 'GG',
    '+224': 'GN',
    '+245': 'GW',
    '+595': 'GY',
    '+509': 'HT',
    '+379': 'VA',
    '+504': 'HN',
    '+852': 'HK',
    '+36': 'HU',
    '+354': 'IS',
    '+91': 'IN',
    '+62': 'ID',
    '+98': 'IR',
    '+964': 'IQ',
    '+353': 'IE',
    '+44': 'IM',
    '+972': 'IL',
    '+39': 'IT',
    '+1876': 'JM',
    '+81': 'JP',
    '+44': 'JE',
    '+962': 'JO',
    '+77': 'KZ',
    '+254': 'KE',
    '+686': 'KI',
    '+850': 'KP',
    '+82': 'KR',
    '+965': 'KW',
    '+996': 'KG',
    '+856': 'LA',
    '+371': 'LV',
    '+961': 'LB',
    '+266': 'LS',
    '+231': 'LR',
    '+218': 'LY',
    '+423': 'LI',
    '+370': 'LT',
    '+352': 'LU',
    '+853': 'MO',
    '+389': 'MK',
    '+261': 'MG',
    '+265': 'MW',
    '+60': 'MY',
    '+960': 'MV',
    '+223': 'ML',
    '+356': 'MT',
    '+692': 'MH',
    '+596': 'MQ',
    '+222': 'MR',
    '+230': 'MU',
    '+262': 'YT',
    '+52': 'MX',
    '+691': 'FM',
    '+373': 'MD',
    '+377': 'MC',
    '+976': 'MN',
    '+382': 'ME',
    '+1664': 'MS',
    '+212': 'MA',
    '+258': 'MZ',
    '+95': 'MM',
    '+264': 'NA',
    '+674': 'NR',
    '+977': 'NP',
    '+31': 'NL',
    '+599': 'AN',
    '+687': 'NC',
    '+64': 'NZ',
    '+505': 'NI',
    '+227': 'NE',
    '+234': 'NG',
    '+683': 'NU',
    '+672': 'NF',
    '+1670': 'MP',
    '+47': 'NO',
    '+968': 'OM',
    '+92': 'PK',
    '+680': 'PW',
    '+970': 'PS',
    '+507': 'PA',
    '+675': 'PG',
    '+595': 'PY',
    '+51': 'PE',
    '+63': 'PH',
    '+872': 'PN',
    '+48': 'PL',
    '+351': 'PT',
    '+1939': 'PR',
    '+974': 'QA',
    '+40': 'RO',
    '+7': 'RU',
    '+250': 'RW',
    '+262': 'RE',
    '+590': 'BL',
    '+290': 'SH',
    '+1869': 'KN',
    '+1758': 'LC',
    '+590': 'MF',
    '+508': 'PM',
    '+1784': 'VC',
    '+685': 'WS',
    '+378': 'SM',
    '+239': 'ST',
    '+966': 'SA',
    '+221': 'SN',
    '+381': 'RS',
    '+248': 'SC',
    '+232': 'SL',
    '+65': 'SG',
    '+421': 'SK',
    '+386': 'SI',
    '+677': 'SB',
    '+252': 'SO',
    '+27': 'ZA',
    '+211': 'SS',
    '+500': 'GS',
    '+34': 'ES',
    '+94': 'LK',
    '+249': 'SD',
    '+597': 'SR',
    '+47': 'SJ',
    '+268': 'SZ',
    '+46': 'SE',
    '+41': 'CH',
    '+963': 'SY',
    '+886': 'TW',
    '+992': 'TJ',
    '+255': 'TZ',
    '+66': 'TH',
    '+670': 'TL',
    '+228': 'TG',
    '+690': 'TK',
    '+676': 'TO',
    '+1868': 'TT',
    '+216': 'TN',
    '+90': 'TR',
    '+993': 'TM',
    '+1649': 'TC',
    '+688': 'TV',
    '+256': 'UG',
    '+380': 'UA',
    '+971': 'AE',
    '+44': 'GB',
    '+1': 'US',
    '+598': 'UY',
    '+998': 'UZ',
    '+678': 'VU',
    '+58': 'VE',
    '+84': 'VN',
    '+1284': 'VG',
    '+1340': 'VI',
    '+681': 'WF',
    '+967': 'YE',
    '+260': 'ZM',
    '+263': 'ZW'
  }
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = ovUtilities
}